import React from 'react';
import PropTypes from 'prop-types';

const Quote = (props) => {
  const {
    prefix,
    text,
    author,
    companyName,
    companyUrl,
    role,
  } = props;

  return (
    <div className={prefix}>
      <div className={`${prefix}_text`}>
        {text}
      </div>
      <div className={`${prefix}_author`}>
        <div className={`${prefix}_author_name`}>
          {author}
        </div>
        {companyName && (
          <div className={`${prefix}_company`}>
            {' - '}
            {companyUrl ? <a href={companyUrl}>{companyName}</a> : companyName}
          </div>
        )}
      </div>
      {role && <div className={`${prefix}_role`}>{role}</div>}
    </div>
  );
};

Quote.defaultProps = {
  companyName: '',
  companyUrl: '',
  role: '',
};
Quote.propTypes = {
  prefix: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  companyName: PropTypes.string,
  companyUrl: PropTypes.string,
  role: PropTypes.string,
};

export default Quote;
